export const _axisLabelColor = 'rgba(33, 25, 9, 1)'
export const _axisLineColor = '#F0F0F0'
